<template lang="html">
  <div id="contact-container">
    <div id="contact">
      <div id = "address">
        <div v-for="(line, i) in addressLines" :key="i"><span>{{ line }}</span></div>
      </div>
      <a :href="'mailto:' + email">
        <div id="email"><span>{{ email }}</span></div>
      </a>
      <a target="_blank" :href="instagramUrl">
        <div id = "email"><span>{{ instagramHandle }}</span></div>
      </a>
    </div>
  </div>
</template>

<script>
import { client } from '../sanity.js'

export default {
  data() {
    return {
      email: 'info@nabiboyd.com',
      addressBlock: 'NABI BOYD\nLOS ANGELES &\nSANTA BARBARA',
      instagramHandle: '@nabiboyd',
      instagramUrl: 'https://www.instagram.com/nabiboyd/',
    }
  },
  computed: {
    addressLines() {
      return this.addressBlock.split('\n').filter(Boolean)
    },
  },
  created() {
    var self = this
    client.fetch('*[_type == "contactSettings" && _id == "contactSettings"][0]{ contactEmail, addressBlock, instagramHandle, instagramUrl }')
      .then(function(s) {
        if (!s) return
        if (s.contactEmail) self.email = s.contactEmail
        if (s.addressBlock) self.addressBlock = s.addressBlock
        if (s.instagramHandle) self.instagramHandle = s.instagramHandle
        if (s.instagramUrl) self.instagramUrl = s.instagramUrl
      })
  },
}
</script>

<style lang="css">
  #contact-container {
    display: flex;
    align-items: center;
    height: 100vh;
  }

  #contact {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    font-size: 5vw;
    color: white;
    height: 75vh;
  }

  #contact a {
    color: white;
  }

  #address {
    text-transform: uppercase;
  }

  #address div {
    padding-bottom: 0.5vw;
  }

  #email {
    padding-bottom: 0.5vw;
  }

  #contact a:hover {
    text-decoration: underline;
  }

  #contact span {
    display: inline;
    background-color: black;
    padding: 0px 10px 5px 10px;
  }

  /* #internet {
    background-color: none;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 13.5vw;
  } */


  @media only screen and (max-width: 768px)  and (orientation : portrait) {
    #contact-container {
      height: 62.5vh;
    }

    #contact {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      font-size: 30px;
      color: white;
      height: 45vh;
      line-height: 1.25em;
    }

    #address div {
      padding-bottom: 0.25vw;
    }

  }
</style>
